import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { ARMClient } from './client.js';

export function useARMClient(): ARMClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(() => new ARMClient(httpClient), [httpClient]);

  return usePanoramaMethodLogger(client);
}
